import { ChartMixed, Clock, Layers, ScalesUnbalanced } from "@gravity-ui/icons";

export const CARDS = [
  {
    icon: Clock,
    title: "Контент готов за минуты",
    elements: ["Мгновенные переводы", "Авто-удаление иероглифов"],
    summary: "Итог: карточки выглядят круто и собираются сами",
  },
  {
    icon: Layers,
    title: "Работа системы без сбоев",
    elements: [
      "Один API вместо десятка интеграций",
      "Высокий RPS - выдерживает высокую нагрузку",
    ],
    summary: "Итог: меньше ручного труда, больше стабильности",
  },
  {
    icon: ScalesUnbalanced,
    title: "Быстрое принятие решений",
    elements: [
      "Данные максимально близки к реальному времени",
      "Вы можете оперативно реагировать на изменения рынка",
    ],
    summary: "Итог: сохранение прибыли",
  },
  {
    icon: ChartMixed,
    title: "На практике:",
    elements: [
      "Каталог расширяется",
      "Рутинные задачи сокращаются",
      "Маржа растёт за счёт прозрачности цен и оперативной выгрузке данных",
    ],
  },
];
